import { render, staticRenderFns } from "./GroupsDropdown.vue?vue&type=template&id=2c03f542&scoped=true&"
import script from "./GroupsDropdown.vue?vue&type=script&lang=ts&"
export * from "./GroupsDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./GroupsDropdown.vue?vue&type=style&index=0&id=2c03f542&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c03f542",
  null
  
)

export default component.exports